var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175.205,
    height: 87.506,
    viewBox: "0 0 175.205 87.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 87.506) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_18",
    "data-name": "Ret\\xE2ngulo 18",
    width: 15.777,
    height: 32.084,
    transform: "translate(71.568 31.864)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 15.777,
    height: 16.934,
    transform: "translate(71.568)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_20",
    "data-name": "Ret\\xE2ngulo 20",
    width: 87.506,
    height: 15.828,
    transform: "translate(0 159.377)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 15.828,
    height: 87.506,
    transform: "translate(71.678 87.699)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.a983ec34182d56a1c40fbf4c46d12458.svg";
export { ForwardRef as ReactComponent };